// Marketplace listing categories. Shared by the edit drawer (fields-other.js),
// the grid filter chips and the listing detail page. Frozen: read-only everywhere.
export const MARKETPLACE_CATEGORIES = Object.freeze([
    Object.freeze({ key: 'weapons', label: 'Våpen', icon: 'fa-duotone fa-crosshairs' }),
    Object.freeze({ key: 'optics', label: 'Optikk', icon: 'fa-duotone fa-binoculars' }),
    Object.freeze({ key: 'ammo', label: 'Ammo og lading', icon: 'fa-duotone fa-boxes-stacked' }),
    Object.freeze({ key: 'clothing', label: 'Bekledning', icon: 'fa-duotone fa-shirt' }),
    Object.freeze({ key: 'other', label: 'Annet', icon: 'fa-duotone fa-box' }),
]);

export function marketplaceCategoryLabel(key) {
    const found = MARKETPLACE_CATEGORIES.find(category => category.key === key);
    return found ? found.label : '';
}

// Days a listing counts as «Ny» in the grid.
export const MARKETPLACE_NEW_DAYS = 7;

export function isNewListing(publishDate) {
    if (!publishDate) {
        return false;
    }
    const ageMs = Date.now() - new Date(publishDate).getTime();
    return ageMs >= 0 && ageMs < MARKETPLACE_NEW_DAYS * 24 * 60 * 60 * 1000;
}

export function isFinnUrl(url) {
    return /^https?:\/\/(www\.)?finn\.no\//i.test(url || '');
}
